import React, { useEffect } from 'react'
import Select from 'react-select';
import { toast } from 'react-toastify';
import _ from 'lodash'
import ErrorBoundary from '../../../../components/ErrorBoundary'

const addUserHandle = ({ users }, userIds, currentWarehouseId, { setAddUser, setViewHandler }, reloadUserData, props) => {

    var data = {
        _id: currentWarehouseId,
        users: users,
    };

    var checkId = _.find(userIds, function (o) { return o === users })

    if (data.users != '') {
        if ((!checkId) || (checkId == [])) {
            props.addDeliveryWarehouseUser(data, props)

            reloadUserData()
            removeHandler(setAddUser, setViewHandler)
            document.getElementById("addUserForm").reset();
        } else {
            toast.error('User already in another warehouse', { autoClose: 2000 });
        }
    } else {
        toast.error('Please fill all mandatory fields!');
    }
}

const removeHandler = (setAddUser, setViewHandler) => {
    let btnSaveEle = document.getElementById('save_user')
    setAddUser({
        users: ''
    })
    setViewHandler({ view: true, add: false, update: false })

    btnSaveEle.disabled = false
}

const AddUser = ({ users, currentWarehouseId, setViewHandler, addUser, setAddUser, isClose, setIsClose, props, userIds, reloadUserData }) => {

    useEffect(() => {
        if (isClose) {
            removeHandler(setAddUser, setViewHandler)
            setIsClose(false)
        }
    }, [isClose])

    return (
        <ErrorBoundary>
            <React.Fragment>
                <form id='addUserForm'>
                    <table style={{ width: '40%' }}>
                        <tbody>
                            <tr>
                                <td style={{ width: '20%', fontSize: "14px" }}>User* :</td>
                                <td style={{ width: '100%' }}>
                                    <div>
                                        <Select
                                            options={users}
                                            value={users.filter((option) => { return option.value === addUser.users })}
                                            theme={theme => ({ ...theme, borderRadius: 0 })}
                                            onChange={(e) => setAddUser({ ...addUser, users: e._id })}
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={4}>
                                    <div style={{ float: 'right', paddingTop: '10px' }}>
                                        <button id='save_user' type="button" className="btn btn-primary" onClick={() => addUserHandle(addUser, userIds, currentWarehouseId, { setAddUser, setViewHandler }, reloadUserData, props)} style={{ marginLeft: "50px" }}>Save</button>
                                        <button type="button" className="btn btn-info" onClick={e => removeHandler(setAddUser, setViewHandler)}>Close</button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </form>
            </React.Fragment>
        </ErrorBoundary>
    )
}

export default AddUser
